export default "__VITE_ASSET__HtLGldKy__"